export function CoreChosenCellDirective ($document, $timeout, $parse) {
  return {
    restrict: 'A',
    link: function (scope, element, attrs) {
      /**
       * for dropdowns that store the object but need to format the selected
       * object and display just a key for example
       * @type {function}
       */
      var format = $parse(attrs.format);

      /**
       * Called whenever the value of the dropdown changes.
       * If there is a format function, call it. Then end edit
       * mode for the cell and focus the next.
       */
      scope.updateRow = function (evt) {
        var parent = $('.ngCell').has(element);
        if (format) {
          scope.$apply(function () {
            format(scope, { $event: evt });
          });
        }

        evt.preventDefault();

        $timeout(function () {
          scope.$emit('ngGridEventEndCellEdit');
          parent.nextAll().has('[ng-cell-has-focus]').find('[ng-cell-has-focus]').has('[editable="true"]').first().trigger('click');
        });
      };

      /**
       * Fires whenever the dropdown's options close.
       * Used as a "blur" replica to end edit mode whenever
       * dropdown loses focus
       */
      scope.closeCell = function () {
        $timeout(function (){
          scope.$emit('ngGridEventEndCellEdit');
        });
      };

      // Open dropdown options on initialization
      $timeout(function () {
        element.trigger('chosen:open');
      });

      /*
       * ng-grid does not play well with the chosen drowdown and navigating through
       * the options so removing the events for key down will leave all the power
       *in this directive's hands
       */
      $('[ng-cell]').has(element).off('keydown');

    }
  };
}